export default __webpack_public_path__ + "static/media/5.1.86d9ecd7.webm";